var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['flip-pic', { 'flip-pic--flipped': _vm.flipped }]},[_c('div',{class:['flip-pic__recto', _vm.recto]}),_c('div',{class:['flip-pic__verso', _vm.verso]})])}
var staticRenderFns = []

export { render, staticRenderFns }